export default __webpack_public_path__ + "static/media/new-york-city-guide.357af3b1.jpg";